import { NgModule } from '@angular/core';
import { OtherComponent } from './other.component';
import { EnterpriseComponent } from './enterprise/enterprise.component';
import { TemplateComponent } from './template/template.component';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { PaginatorModule } from 'primeng/primeng';
import { Select2Module } from 'ng2-select2';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { UploadEvsService } from '../../../../../common/services/UploadEvs.service';
import { ContactService } from '../../../../../common/services/Contact.service';
import { AccountService } from '../../../../../common/services/Account.service';
import { ComponentsModule } from '../../../../../components/component.module';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    PaginatorModule,
    Select2Module,
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    ComponentsModule,
    RouterModule,
  ],
  declarations: [OtherComponent, EnterpriseComponent, TemplateComponent],
  exports: [OtherComponent, TemplateComponent, EnterpriseComponent],
  providers: [AccountService],
})
export class OtherModule {}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/other/other.module.ts